import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";

const ListProviders = {};

@Injectable({
    providedIn: 'root'
})
export class ListService {

    constructor(private http: HttpClient) {
    }

    // æ·»å ä¸ä¸ªèªå®ä¹æå¡
    static addProvider(name, fn: (http: HttpClient, invokeParam?: any, param?: any) => any) {
        ListProviders[name] = fn;
    }

    // è°ç¨èªå®ä¹æå¡
    invokeListProvider<T>(name, invokeParam?, param?): Observable<T> {
        return ListProviders[name](this.http, invokeParam, param);
    }
}
